/**
 * 搜索入口语义统一（2026-09-19，搜索跳转语义修复）
 *
 * 背景：类目词入口（首页五格 fallback 槽 / 猜你想搜 / 热搜·联想·历史里的类目词）
 * 此前一律走 /result?id=轮胎 关键词搜索——全字段召回"轮胎"字样而非轮胎类目列表，
 * 且上报 search/log 污染热搜统计。语义应为：类目词 → 规格筛选上下文（类目默认全量），
 * 自由词（车型 CG125 / 品牌 / 编码 / 商品名）→ 普通关键词搜索。
 *
 * 本模块是"词 → 类目上下文"判定的唯一真值：
 *   matchSpecCategory(text)  精确匹配类目中文名/别名 → { key, name } | null
 *   specResultQuery(...)     构造 /result 规格筛选 route query（spec 字段集为空时不带 spec 参数）
 *
 * 协议（/result?type=spec）：
 *   category=<SPEC_FIELD_MAP key>     类目上下文（必带；后端 spec_search.category = p.category 过滤）
 *   categoryName=<入口用词>            仅展示用（"电瓶"而非字典名"电池"，忠实用户词）
 *   spec=<JSON 已选规格字段集>         仅非空时携带；取消全部规格 = 移除该参数（不留脏空值）
 *   model=<车型名>                     keyword/car 来源下叠加的车型 facet
 * 旧协议（spec JSON 内含 category/categoryName）仅兼容读取（历史栈/书签），不再产生。
 */

import { buildSpecCategories, SPEC_CATEGORY_META, specCategoryName } from './specFieldMap'

// 中文名 → category key（buildSpecCategories 已覆盖 SPEC_FIELD_MAP 全部键）
const NAME_TO_KEY = {}
buildSpecCategories().forEach(c => { if (c.name) NAME_TO_KEY[c.name] = c.key })

// 行业别名（用户口语 ≠ 字典名）：电瓶=电池。只收无歧义词，宁缺毋滥
const CATEGORY_ALIASES = {
  电瓶: 'battery',
  蓄电池: 'battery',
  机油: 'oil',
  润滑油: 'oil'
}

/**
 * 词 → 类目上下文。仅精确匹配（trim 后全等）：联想/热搜里"正新轮胎 90/90-10"这类
 * 商品名是自由词，走关键词搜索；整词恰为类目名（含别名）才进规格筛选。
 * @returns {{key:string, name:string}|null}
 */
export function matchSpecCategory (text) {
  const t = String(text || '').trim()
  if (!t) return null
  const key = NAME_TO_KEY[t] || CATEGORY_ALIASES[t]
  if (!key) return null
  return { key, name: (SPEC_CATEGORY_META[key] && SPEC_CATEGORY_META[key].name) || specCategoryName(key) }
}

/**
 * 构造 /result 规格筛选 query（route 为筛选状态唯一真值）
 * @param {{category:string, categoryName?:string, spec?:Object}} ctx
 *   spec 为已选规格字段集（{width:'2.75-18'}）；空对象/空串值剔除，全空则不带 spec 参数
 */
export function specResultQuery (ctx) {
  const spec = {}
  Object.keys(ctx.spec || {}).forEach(k => {
    const v = ctx.spec[k]
    if (v !== undefined && v !== null && v !== '') spec[k] = v
  })
  const query = {
    type: 'spec',
    category: ctx.category,
    categoryName: ctx.categoryName || specCategoryName(ctx.category)
  }
  if (Object.keys(spec).length > 0) query.spec = JSON.stringify(spec)
  return query
}
